import i18n, { TFunction } from "i18next";

import { GENERIC_FILTER_WITHOUT_SELECT } from "shared/filterDefinitions";
import { DataType } from "shared/types";

import { FilterType } from "features/ui/Filters/types";
import { SchemaEntry } from "features/ui/MaterialTable";

import { UseSchema } from "./types";

const getFleetsSchema = (t: TFunction): SchemaEntry[] => [
  {
    label: t("common:name"),
    accessor: "name",
    dataType: DataType.STRING,
    filter: {
      label: t("common:name"),
      fieldName: "fleet",
      fieldNameForAPI: "fleet",
      filterType: FilterType.STRING,
      search: true,
      valuesEndpoint: "vehicles",
    },
  },
  {
    label: t("pages:fleets.total_trucks"),
    accessor: "numVehicles",
    dataType: DataType.NUMBER,
    sortable: true,
    filter: GENERIC_FILTER_WITHOUT_SELECT({
      label: t("pages:fleets.total_trucks"),
      fieldName: "numVehicles",
      filterType: FilterType.NUMBER,
      onlyAllowPositiveIntegers: true,
    }),
  },
];

export const useFleetsSchema = (): UseSchema => {
  const t = i18n.t;
  const FLEETS_SCHEMA = getFleetsSchema(t);

  const attributeAccessors = FLEETS_SCHEMA.map(
    ({ accessor, filter }) => filter?.fieldName || accessor
  );

  const getDisplayLabel = (accessor: string, defaultLabel: string) =>
    FLEETS_SCHEMA.find((entry) => entry.accessor === accessor)?.label ||
    defaultLabel;

  const getSchemaEntry = (accessor: string) =>
    FLEETS_SCHEMA.find((entry) => entry.accessor === accessor);

  const getSchemaForAccessor = (accessor: string) =>
    FLEETS_SCHEMA.find((entry) => entry.accessor === accessor);

  return {
    schema: FLEETS_SCHEMA,
    attributes: [],
    attributeAccessors,
    groupBySelectOptions: [],
    getDisplayLabel,
    getSchemaEntry,
    getSchemaForAccessor,
  };
};
